import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

const { FiArrowRight, FiLayers } = FiIcons;

const RelatedSolutions = ({ links = [] }) => {
  const { lang } = useLanguage();
  
  if (links.length === 0) return null;

  const labels = {
    en: {
      heading: "Explore More Solutions",
      subheading: "Strategic systems to help your business grow."
    },
    es: {
      heading: "Explora Más Soluciones",
      subheading: "Sistemas estratégicos para ayudar a tu negocio a crecer."
    }
  };

  const t = labels[lang] || labels.en;

  return (
    <section className="py-20 px-6 bg-zinc-950 border-t border-white/5">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div>
            <div className="flex items-center gap-2 text-orange-500 mb-4">
              <SafeIcon icon={FiLayers} className="text-xl" />
              <span className="text-xs font-black uppercase tracking-[0.2em]">{t.heading}</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-white tracking-tighter uppercase">
              {t.subheading}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {links.map((link, index) => (
            <motion.div
              key={link.path}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <Link
                to={link.path}
                className="group block p-8 bg-zinc-900 border border-white/5 rounded-3xl hover:border-orange-500/30 transition-all duration-500 relative overflow-hidden"
              >
                <div className="absolute top-0 right-0 p-6 opacity-0 group-hover:opacity-100 transition-opacity">
                  <SafeIcon icon={FiArrowRight} className="text-2xl text-orange-500 -rotate-45 group-hover:rotate-0 transition-transform duration-500" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-orange-500 transition-colors">
                  {link.label}
                </h3>
                <p className="text-zinc-500 text-sm leading-relaxed">
                  {link.description}
                </p>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedSolutions;